import { render, staticRenderFns } from "./OrganismTitleAndDescription.vue?vue&type=template&id=17f72cef&"
import script from "./OrganismTitleAndDescription.vue?vue&type=script&lang=js&"
export * from "./OrganismTitleAndDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCommonAtomTitleAndDescription: require('/app/components/atoms/common/AtomTitleAndDescription.vue').default,MoleculesCommonMoleculeTitleAndDescription: require('/app/components/molecules/common/MoleculeTitleAndDescription.vue').default})
